import ItemTypeModal from './item-type-modal';

export default ItemTypeModal;
